import { Button,  colors, Grid, Paper } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { BeatLoader } from "react-spinners";
import { useStylesSpDial, useStylesUiElemment } from "../../../../St/comps/UseStyle";
import ItemCard from "./ItemCard";

function RestItemsG(props) {
  const { group, values,data,loading } = props;
  // const [page, setPage] = useState(0);
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  return (
    <Paper style={{ padding: "8px" ,}}>
      <Grid container spacing={1} >
        {data?.map((item, i) => {
          const index = values.findIndex((x) => x.barcode == item.barcode);
          if (index != -1) console.log("the value", values[index].val1);
          const count = index == -1 ? 0 : values[index].val1;
          return (
            <Grid item key={i} lg={2} md={3} sm={3} xs={6}>
              <ItemCard
                item={item}
                onClick={props.onSelectItem}
                count={count}
                group={group}
              />
            </Grid>
          );
        })}
        <Grid xs={12} container justifyContent="center">
          <BeatLoader loading={loading} color={colors.green[300]} />
        </Grid>
        {loading && (
          <Grid xs={12} container justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={[clasui.button, clasSp.clSec]}
              disabled={loading}
            >
              تحميل المزيد
            </Button>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}

export default RestItemsG;
